import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  white-space: nowrap;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        ", ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import theme from "../theme";
import { Box, Link as CoreLink, Button as CoreButton, useWindowSize } from "@miro-site/core";
import SecondaryNavigation from "./SecondaryNavigation";
import Highlighted from "./Highlighted";
import CustomerSpotlight from "./CustomerSpotlight";
import TemplatesHighilighted from "./TemplatesHighlighted";
import { Transition } from "react-transition-group";
var appearanceColorMap = {
    dark: {
        buttonColor: theme.header.topNavigation.whiteColor,
        buttonExpandedColor: theme.colors.outspoken,
        linkColor: theme.header.topNavigation.whiteColor,
        linkHoverColor: theme.colors.outspoken,
        linkIndicatorBackground: theme.colors.outspoken
    },
    light: {
        buttonColor: theme.header.topNavigation.color,
        buttonExpandedColor: theme.header.topNavigation.hoverColor,
        linkColor: theme.header.topNavigation.color,
        linkHoverColor: theme.header.topNavigation.hoverColor,
        linkIndicatorBackground: theme.colors.primaryBlueHover
    }
};
var Link = styled(CoreLink).attrs(function(param) {
    var $appearance = param.$appearance, _$theme = param.theme;
    return {
        $styles: {
            color: appearanceColorMap[$appearance].linkColor,
            ":hover": {
                color: appearanceColorMap[$appearance].linkHoverColor
            }
        }
    };
}).withConfig({
    componentId: "sc-956d183d-0"
})(_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.normalizeStyles({
        transition: "color ".concat(_$theme.animation.transitionDuration),
        fontSize: _$theme.header.topNavigation.fontSize,
        lineHeight: _$theme.header.topNavigation.lineHeight,
        ":focus": _object_spread({}, _$theme.focus.outlines.withOffset)
    });
});
var getChevronBackground = function(color) {
    return "url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='".concat(encodeURIComponent(color), "' stroke-width='1.5'/%3E%3C/svg%3E%0A\")");
};
var Button = styled(CoreButton).attrs(function(props) {
    return {
        "data-top-navigation-button": 1,
        "aria-haspopup": true,
        "aria-expanded": !!props.$isExpanded
    };
}).withConfig({
    componentId: "sc-956d183d-1"
})(_templateObject1(), function(param) {
    var _$theme = param.theme, $isExpanded = param.$isExpanded, $appearance = param.$appearance;
    return _$theme.normalizeStyles({
        transition: "color ".concat(_$theme.animation.transitionDuration),
        fontSize: _$theme.header.topNavigation.fontSize,
        lineHeight: _$theme.header.topNavigation.lineHeight,
        color: $isExpanded ? appearanceColorMap[$appearance].buttonExpandedColor : appearanceColorMap[$appearance].buttonColor,
        ":hover": {
            color: appearanceColorMap[$appearance].buttonExpandedColor,
            ".focus-trap:after": {
                backgroundImage: getChevronBackground(appearanceColorMap[$appearance].buttonExpandedColor)
            }
        },
        ":focus": _object_spread({}, _$theme.focus.outlines.withOffset),
        ".focus-trap:after": {
            transition: _$theme.header.topNavigation.animation.chevron,
            transform: $isExpanded ? "rotate(-180deg)" : "rotate(0)",
            display: "inline-block",
            marginLeft: 8,
            content: "''",
            width: 10,
            height: 10,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundImage: getChevronBackground($isExpanded ? appearanceColorMap[$appearance].buttonExpandedColor : appearanceColorMap[$appearance].buttonColor),
            position: "relative",
            top: [
                null,
                2,
                2,
                2,
                null
            ]
        }
    });
});
var List = styled(Box).attrs(function(param) {
    var _$theme = param.theme;
    return {
        as: "ul",
        role: "menu",
        $styles: {
            display: "flex",
            alignItems: "center"
        }
    };
}).withConfig({
    componentId: "sc-956d183d-2"
})(_templateObject2(), Link, Button);
List.displayName = "TopNavigation.List";
var Container = styled(Box).attrs(function(param) {
    var _$theme = param.theme;
    return {
        $styles: {
            display: [
                "none",
                "none",
                "flex"
            ],
            marginLeft: _$theme.header.topNavigation.leftOffset,
            alignItems: "center",
            alignSelf: "stretch"
        }
    };
}).withConfig({
    componentId: "sc-956d183d-3"
})(_templateObject3());
Container.displayName = "TopNavigation.Container";
var LinkIndicator = function(props) {
    var activeNavigation = props.activeNavigation, activeItemRef = props.activeItemRef, appearance = props.appearance;
    var ref = useState([
        0,
        0
    ]), indicatorPosition = ref[0], setIndicatorPosition = ref[1];
    var _$theme = useTheme();
    var width = useWindowSize().width;
    var _indicatorPosition = _sliced_to_array(indicatorPosition, 2), indicatorOffset = _indicatorPosition[0], indicatorWidth = _indicatorPosition[1];
    useEffect(function() {
        if (activeItemRef.current) {
            var item = activeItemRef.current;
            var itemOffset = item.offsetLeft;
            var itemRect = item.getBoundingClientRect();
            var itemComputedStyle = window.getComputedStyle(item, null);
            var paddingLeft = parseFloat(itemComputedStyle.paddingLeft);
            var paddingRight = parseFloat(itemComputedStyle.paddingRight);
            var itemWidth = itemRect.width - paddingLeft - paddingRight;
            setIndicatorPosition([
                itemOffset + paddingLeft,
                itemWidth
            ]);
        } else {
            setIndicatorPosition(function(prev) {
                return [
                    prev[0],
                    0
                ];
            });
        }
    }, [
        activeNavigation,
        width
    ]);
    var states = {
        entering: {
            transition: "none 0s ease 0s",
            transform: "translateX(".concat(indicatorOffset, "px) scaleX(0)")
        }
    };
    return /*#__PURE__*/ _jsx(Transition, {
        in: activeNavigation !== null,
        timeout: 0,
        children: function(state) {
            return /*#__PURE__*/ _jsx(Box, {
                $styles: _object_spread({
                    transformOrigin: "left",
                    transition: _$theme.header.topNavigation.animation.linkIndicator,
                    transform: "translateX(".concat(indicatorOffset, "px) scaleX(").concat(indicatorWidth / 100, ")"),
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100px",
                    height: 2,
                    background: appearanceColorMap[appearance].linkIndicatorBackground
                }, states[state] || {})
            });
        }
    });
};
LinkIndicator.displayName = "LinkIndicator";
var Item = styled.li.attrs({
    role: "menuitem"
}).withConfig({
    componentId: "sc-956d183d-4"
})(_templateObject4(), function(props) {
    return props.theme.normalizeStyles({
        paddingLeft: props.theme.header.topNavigation.gutter,
        paddingRight: props.theme.header.topNavigation.gutter,
        ":first-child": {
            paddingLeft: 0
        },
        ":last-child": {
            paddingRight: 0
        }
    });
});
Item.displayName = "TopNavigation.Item";
var TopNavigation = function(props) {
    var activeNavigation = props.activeNavigation, activeNavigationRef = props.activeNavigationRef, onToggleNavigation = props.onToggleNavigation, productNavigation = props.productNavigation, whatsNew = props.whatsNew, solutionsNavigation = props.solutionsNavigation, templates = props.templates, resourcesNavigation = props.resourcesNavigation, customerSpotlight = props.customerSpotlight, enterpriseLink = props.enterpriseLink, pricingLink = props.pricingLink, appearance = props.appearance;
    var prevNavigation = useRef(null);
    var activeItemRef = useRef(null);
    useEffect(function() {
        prevNavigation.current = activeNavigation;
    }, [
        activeNavigation
    ]);
    var setActiveNavigationRef = function(navigationIndex, ref) {
        if (!activeNavigationRef) {
            return;
        }
        if (activeNavigation === null) {
            activeNavigationRef.current = null;
        }
        if (navigationIndex === activeNavigation) {
            activeNavigationRef.current = ref;
        }
    };
    var setactiveItemRef = function(navigationIndex, ref) {
        if (activeNavigation === null) {
            activeItemRef.current = null;
        }
        if (navigationIndex === activeNavigation) {
            activeItemRef.current = ref;
        }
    };
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(List, {
                "data-track-place": "Header",
                children: [
                    /*#__PURE__*/ _jsxs(Item, {
                        ref: function(ref) {
                            return setactiveItemRef(0, ref);
                        },
                        $isExpanded: activeNavigation === 0,
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                "data-track-id": "top-navigation-button",
                                "aria-controls": "product-navigation",
                                $isExpanded: activeNavigation === 0,
                                $appearance: appearance,
                                onClick: function() {
                                    return onToggleNavigation(0);
                                },
                                children: productNavigation.title
                            }),
                            /*#__PURE__*/ _jsx(SecondaryNavigation, {
                                id: "product-navigation",
                                ref: function(ref) {
                                    return setActiveNavigationRef(0, ref);
                                },
                                index: 0,
                                prevNavigation: prevNavigation.current,
                                nextNavigation: activeNavigation,
                                navigationGroups: productNavigation.groups,
                                highlightedContent: whatsNew ? /*#__PURE__*/ _jsx(Highlighted, _object_spread({}, whatsNew)) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Item, {
                        ref: function(ref) {
                            return setactiveItemRef(1, ref);
                        },
                        $isExpanded: activeNavigation === 1,
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                "data-track-id": "top-navigation-button",
                                "aria-controls": "solutions-navigation",
                                $isExpanded: activeNavigation === 1,
                                $appearance: appearance,
                                onClick: function() {
                                    return onToggleNavigation(1);
                                },
                                children: solutionsNavigation.title
                            }),
                            /*#__PURE__*/ _jsx(SecondaryNavigation, {
                                id: "solutions-navigation",
                                ref: function(ref) {
                                    return setActiveNavigationRef(1, ref);
                                },
                                index: 1,
                                prevNavigation: prevNavigation.current,
                                nextNavigation: activeNavigation,
                                navigationGroups: solutionsNavigation.groups,
                                highlightedContent: templates ? /*#__PURE__*/ _jsx(TemplatesHighilighted, _object_spread({}, templates)) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Item, {
                        ref: function(ref) {
                            return setactiveItemRef(2, ref);
                        },
                        $isExpanded: activeNavigation === 2,
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                "data-track-id": "top-navigation-button",
                                "aria-controls": "resources-navigation",
                                $isExpanded: activeNavigation === 2,
                                $appearance: appearance,
                                onClick: function() {
                                    return onToggleNavigation(2);
                                },
                                children: resourcesNavigation.title
                            }),
                            /*#__PURE__*/ _jsx(SecondaryNavigation, {
                                id: "resources-navigation",
                                ref: function(ref) {
                                    return setActiveNavigationRef(2, ref);
                                },
                                index: 2,
                                prevNavigation: prevNavigation.current,
                                nextNavigation: activeNavigation,
                                navigationGroups: resourcesNavigation.groups,
                                highlightedContent: customerSpotlight ? /*#__PURE__*/ _jsx(CustomerSpotlight, _object_spread({}, customerSpotlight)) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Item, {
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: enterpriseLink.path,
                            $appearance: appearance,
                            children: enterpriseLink.title
                        })
                    }),
                    /*#__PURE__*/ _jsx(Item, {
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: pricingLink.path,
                            $appearance: appearance,
                            children: pricingLink.title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LinkIndicator, {
                activeNavigation: activeNavigation,
                activeItemRef: activeItemRef,
                appearance: appearance
            })
        ]
    });
};
export default Object.assign(TopNavigation, {
    Link: Link,
    Button: Button,
    Item: Item
});
